import React, { useEffect, useState } from 'react';
import TextField                      from '@mui/material/TextField';
import Autocomplete                   from '@mui/material/Autocomplete';
import { connect }                    from 'react-redux';
import { useTranslation }             from 'react-i18next';
import { fetchTags }                  from '../../../store/actions/CmsAction';

const CmsTagsAutocomplete = ({ value, setValue, cms, fetchTags, loading, tags, ...rest }) => {
	const { t } = useTranslation();
	const [options, setOptions] = useState([]);

	useEffect(() => {
		if (!cms) return;
		fetchTags(cms.Classify.Classify__);
	}, [fetchTags, cms]);

	useEffect(() => {
		if (!tags) return;
		setOptions(tags.map(t => t.Name));
	}, [tags, setOptions]);

	return (
		<Autocomplete
			multiple
			value={value ?? []}
			onChange={(event, newValue) => {
				setValue(newValue);
			}}
			options={options ?? []}
			renderInput={(params) => <TextField {...params} label={t('cms_search_tags')} variant='outlined'/>}
			{...rest}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		tags: state.cms.selectedTags,
		loading: state.cms.selectedTagsLoading,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchTags: (classifyId) => dispatch(fetchTags(classifyId))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CmsTagsAutocomplete);

